import {
  Layout,
  Col,
  Row,
  Typography,
  Radio,
  Popconfirm,
  Modal,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import {
  getAllSkills,
  addSkill,
  deleteSkill,
  updateSkill,
} from "../Redux/admin/reducer";
import Feedback from "../Utilities/Feedback";
import {
  LoadingOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import {
  StyledButton,
  StyledCheckTag,
  StyledText,
} from "../styled-components/components";
import { NavLink } from "react-router-dom";
import { Formik } from "formik";
import { Form } from "formik-antd";
import { FormikInput, FormikSubmitButton } from "../FormItems";
import * as Yup from "yup";
import { Helmet } from "react-helmet";

const AdminHeader = () => {
  return (
    <Col xs={{ span: 24 }} style={{ background: "#ffffff", padding: "2vh" }}>
      <NavLink
        to="/admin/home"
        activeClassName="selected"
        activeStyle={{
          color: "#1565d8",
          fontSize: "16px",
          fontWeight: "600",
        }}
        data-testid="submit-admin-home"
      >
        Home
      </NavLink>
    </Col>
  );
};

const AdminHome = ({
  fetchAllSkills,
  newSkill,
  deleteSkillById,
  updateSkillByDetails,
}) => {
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [radioValue, setRadioValue] = useState("Functional");
  const [skillHeadValues, setSkillHeadValues] = useState([]);
  useEffect(() => {
    const getAllSkills = async () => {
      await fetchAllSkills();
      setLoading(false);
    };
    getAllSkills();
  }, [fetchAllSkills]);
  const { allSkills } = useSelector((state) => state.adminStore);
  useEffect(() => {
    const skillHeadings = allSkills.filter((skill) => !skill.parentId);
    setSkillHeadValues([...skillHeadings]);
  }, [allSkills]);

  const getSubSkillSet = (parentName) => {
    const mainSkills = allSkills.filter((skill) => !skill.parentId);
    const reqSkill = mainSkills.filter((skill) => skill.name === parentName);
    return allSkills.filter((skill) => skill.parentId === reqSkill[0].id);
  };
  const changeRadioValue = (event) => {
    setRadioValue(event.target.value);
  };
  const mainHeadings = skillHeadValues.map((skill) => (
    <Col key={skill.id}>
      <Radio data-testid={`category-${skill.id}`} value={skill.name}>
        {skill.name}
      </Radio>
    </Col>
  ));
  const initialValues = {
    skillName: "",
  };
  const validationSchema = Yup.object().shape({
    skillName: Yup.string().required("Name is required"),
  });
  const addSkill = async (formValues, formActions) => {
    const details = {
      type: "SKILL_HEADING",
      name: formValues.skillName,
      parentId: "",
    };
    await newSkill(details);
    formActions.setSubmitting(false);
    formActions.resetForm();
    message.success(`${formValues.skillName} added Successfully`, 3);
    setOpenModal(false);
  };
  return (
    <Layout>
      <AdminHeader />
      <Layout.Content>
        <Helmet title="Home | Unicon"></Helmet>
        <Col>
          {loading ? (
            <Col>
              <Feedback icon={<LoadingOutlined />} title="Fetching Skills" />
            </Col>
          ) : (
            <Col xl={{ span: 22 }}>
              <Row justify="space-between">
                <Col flex={1} style={{ padding: "2vh" }}>
                  <Col xl={{ span: 24 }}>
                    <Row>
                      <Col style={{ marginRight: "2vh" }}>
                        <Typography.Title level={5}>
                          SKILL_CATEGORY
                        </Typography.Title>
                      </Col>
                      <Col style={{ marginTop: "0.25vh" }}>
                        <PlusCircleOutlined
                          data-testid="openCategory"
                          onClick={() => setOpenModal(true)}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Row>
                    <Col>
                      <Radio.Group
                        value={radioValue}
                        onChange={changeRadioValue}
                      >
                        {mainHeadings}
                      </Radio.Group>
                    </Col>
                  </Row>
                </Col>
                <Col flex={5} style={{ marginTop: "2vh" }}>
                  <Row>
                    <SubSkills
                      parentSkillName={radioValue}
                      allSkills={allSkills}
                      subSkillSet={getSubSkillSet(radioValue)}
                      newSkill={newSkill}
                      deleteSkillById={deleteSkillById}
                      updateSkillByDetails={updateSkillByDetails}
                    />
                  </Row>
                </Col>
              </Row>
            </Col>
          )}
        </Col>
        <Modal
          visible={openModal}
          onCancel={() => setOpenModal(false)}
          footer={null}
        >
          <Col>
            <NewSkillForm
              title="New Skill Category"
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={addSkill}
            />
          </Col>
        </Modal>
      </Layout.Content>
    </Layout>
  );
};

const SubSkills = ({
  parentSkillName,
  subSkillSet,
  allSkills,
  newSkill,
  deleteSkillById,
  updateSkillByDetails,
}) => {
  const [modalOpen, setOpenModal] = useState(false);
  const [openSkillModal, setOpenSkillModal] = useState(false);
  const [selectedSkillParentName, setSelectedSkillParentName] = useState("");
  const initialValues = {
    skillName: "",
  };
  const validationSchema = Yup.object().shape({
    skillName: Yup.string().required("Name is required"),
  });
  const getSkills = (parentId) => {
    return allSkills.filter((skill) => skill.parentId === parentId);
  };
  const getParentId = (parentName) =>
    allSkills.filter((skill) => skill.name === parentName)[0].id;
  const addSubSkill = async (formValues, formActions) => {
    const details = {
      type: "SKILL_SUB_HEADING",
      parentId: getParentId(parentSkillName),
      name: formValues.skillName,
    };
    await newSkill(details);
    formActions.setSubmitting(false);
    message.success(`${formValues.skillName} added Successfully`, 3);
    formActions.resetForm();
    setOpenModal(false);
  };
  const addNewSkill = async (formValues, formActions) => {
    const details = {
      type: "SKILL",
      parentId: getParentId(selectedSkillParentName),
      name: formValues.skillName,
    };
    await newSkill(details);
    formActions.setSubmitting(false);
    message.success(`${formValues.skillName} added Successfully`, 3);
    formActions.resetForm();
    setOpenSkillModal(false);
  };
  const deleteSelectedSkill = async (skillId) => {
    message.loading("Deleting Skill", 2);
    await deleteSkillById(skillId);
    message.success("Skill Deleted Successfully", 3);
  };
  return (
    <Col xl={{ span: 20 }}>
      <Col xl={{ span: 12 }}>
        <Row>
          <Col style={{ marginTop: "0.5vh", marginRight: "4vh" }}>
            <Typography.Title level={4}>Skills</Typography.Title>
          </Col>
          <Col>
            <StyledButton
              textColor="#100e12"
              color="#17B6EA"
              onClick={() => setOpenModal(true)}
            >
              New Sub Skill
            </StyledButton>
          </Col>
        </Row>
      </Col>
      {subSkillSet &&
        subSkillSet.map((eachSub) => (
          <Col
            key={eachSub.id}
            style={{
              padding: "2vh",
              background: "#ffffff",
              border: "1px solid #f4f4f4",
              margin: "2vh",
              marginLeft: "auto",
              marginRight: "auto",
              borderRadius: "4px",
              boxShadow: "2px 2px 4px #19192C",
            }}
          >
            <Col xl={{ span: 24 }}>
              <Row>
                <Col style={{ marginRight: "2vh" }}>
                  <Typography.Title level={5}>{eachSub.name}</Typography.Title>
                </Col>
                <Col style={{ marginTop: "0.25vh" }}>
                  <PlusCircleOutlined
                    data-testid="openSubCategory"
                    onClick={() => {
                      setSelectedSkillParentName(eachSub.name);
                      setOpenSkillModal(true);
                    }}
                  />
                </Col>
              </Row>
            </Col>
            <Skills
              updateSkillByDetails={updateSkillByDetails}
              deleteSkill={deleteSelectedSkill}
              skills={getSkills(eachSub.id)}
            />
          </Col>
        ))}

      <Modal
        visible={openSkillModal}
        onCancel={() => setOpenSkillModal(false)}
        footer={null}
      >
        <Col>
          <NewSkillForm
            title="New Skill"
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={addNewSkill}
          />
        </Col>
      </Modal>
      <Modal
        visible={modalOpen}
        onCancel={() => setOpenModal(false)}
        footer={null}
      >
        <Col>
          <NewSkillForm
            title="New Sub-Category"
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={addSubSkill}
          />
        </Col>
      </Modal>
    </Col>
  );
};

const Skills = ({ skills, deleteSkill, updateSkillByDetails }) => {
  const [initialValues, setInitialValues] = useState({});
  const [skillId, setSkillId] = useState("");
  const validationSchema = Yup.object().shape({
    skillName: Yup.string().required("Name is required"),
  });
  const [openModal, setOpenModal] = useState(false);
  const openForm = (name, id) => {
    const skillName = name;
    setSkillId(id);
    setInitialValues({ skillName });
    setOpenModal(true);
  };
  const updateSelectedSkill = async (formValues, formActions) => {
    const skillDetails = {
      name: formValues.skillName,
      id: skillId,
    };
    await updateSkillByDetails(skillDetails);
    formActions.setSubmitting(false);
    setOpenModal(false);
  };

  return (
    <Col>
      <Row>
        {skills &&
          skills.map((skill) => (
            <Col key={skill.id}>
              <StyledCheckTag data-testid={`tag-${skill.id}`}>
                <EditOutlined onClick={() => openForm(skill.name, skill.id)} />
                <StyledText textColor="#100e12">{skill.name}</StyledText>
                <Popconfirm
                  title="Delete this skill"
                  icon={<DeleteOutlined style={{ color: "red" }} />}
                  onConfirm={() => deleteSkill(skill.id)}
                  okType="dashed"
                  okText="Confirm"
                  placement="top"
                >
                  <CloseCircleOutlined data-testid="submit-removeSkill" />
                </Popconfirm>
              </StyledCheckTag>
            </Col>
          ))}
        <Row>
          {skills.length === 0 ? (
            <Col>
              <Typography.Paragraph level={5}>No Skills</Typography.Paragraph>
            </Col>
          ) : null}
        </Row>
      </Row>
      <Modal
        footer={null}
        visible={openModal}
        onCancel={() => setOpenModal(false)}
      >
        <Col>
          <NewSkillForm
            title="Update Skill"
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={updateSelectedSkill}
            submitButtonName="Update"
          />
        </Col>
      </Modal>
    </Col>
  );
};

const NewSkillForm = (props) => {
  return (
    <Col>
      <Row>
        <Typography.Title level={4}>{props.title}</Typography.Title>
      </Row>
      <Formik
        initialValues={props.initialValues}
        validationSchema={props.validationSchema}
        validateOnMount
        onSubmit={props.onSubmit}
      >
        {(formik) => {
          return (
            <Form>
              <Col xl={{ span: 16 }}>
                <FormikInput
                  id="skillName"
                  label="Skill Name"
                  name="skillName"
                  value={props.initialValues}
                />
              </Col>
              <Col xl={{ span: 16 }}>
                <FormikSubmitButton
                  id="submit-addSkill"
                  disabled={!formik.isValid}
                  name={props.submitButtonName ? props.submitButtonName : "Add"}
                />
              </Col>
            </Form>
          );
        }}
      </Formik>
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAllSkills: () => dispatch(getAllSkills()),
    newSkill: (skillDetails) => dispatch(addSkill(skillDetails)),
    deleteSkillById: (skillId) => dispatch(deleteSkill(skillId)),
    updateSkillByDetails: (skillDetails) => dispatch(updateSkill(skillDetails)),
  };
};

export default connect(null, mapDispatchToProps)(AdminHome);
